import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { map, Observable } from 'rxjs';
import { CONFIGURATOR_BASE_URL } from '../../app.config';
import { GetSiteConfigurationResponse } from '../../shared/get-site-configuration.response';
import { SiteConfiguration } from '../../shared/site-configuration.model';
import { GetSiteConfigurationByKeyRequest } from './get-site-configuration-by-key.request';

@Injectable({
    providedIn: 'root',
})
export class GetSiteConfigurationByKeyUseCase extends UseCase<GetSiteConfigurationByKeyRequest, Observable<SiteConfiguration>> {
    private _apiRequestService = inject(ApiRequestService);
    private _configuratorBaseUrl = inject<string>(CONFIGURATOR_BASE_URL);
    private _getSiteConfigurationUrl = '/websiteconfigurator/get-site-configuration';

    constructor(_logService: LogService, protected override _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: GetSiteConfigurationByKeyRequest | void): Observable<SiteConfiguration> | void {
        const configurationKey = (request as GetSiteConfigurationByKeyRequest).configurationKey;
        return this._apiRequestService
            .sendRequest<{}, GetSiteConfigurationResponse>(this._configuratorBaseUrl, {}, true, this._getSiteConfigurationUrl)
            .pipe(
                map((response) => {
                    const siteConfigurationList = response.siteConfigurationList as SiteConfiguration[];
                    const entry = siteConfigurationList.find((config) => config.configurationKey === configurationKey);
                    return entry ?? { configurationKey: configurationKey, configurationValue: '', active: true };
                })
            );
    }
}
